import { useCallback, useEffect, useState } from "react";
import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import { BacktoMyAccount } from "../backToMyAccount";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { axiosInstance } from "../../../axios/axiosInstance";
import { PAGES } from "../../../routeConfig";

const formatDate = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (isNaN(parsed.getTime())) return "-";
  return parsed.toLocaleDateString("en-AU", { day: "2-digit", month: "short", year: "numeric" });
};

export const AiAccessTokens = () => {
  const { showDialogAlert, showNoteAlert, hideNoteAlert } = useNoteAlert();

  const [grants, setGrants] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadGrants = useCallback(() => {
    setLoading(true);
    axiosInstance
      .get("mcp/oauth/grants")
      .then((response) => {
        setGrants(response?.data?.data || []);
      })
      .catch(() => {
        setGrants([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    loadGrants();
  }, [loadGrants]);

  const handleDisconnect = (grant) => {
    showDialogAlert({
      content: `This disconnects <b>${grant.clientName}</b> straight away. It will have to be approved again before it can touch your cart.`,
      title: "Disconnect Application",
      primaryBtn: {
        caption: "Yes, Disconnect",
        onClick: () => {
          hideNoteAlert();
          axiosInstance
            .post("mcp/oauth/grants/revoke", { clientId: grant.clientId })
            .then(() => loadGrants())
            .catch((error) => {
              showNoteAlert(error?.response?.data?.message || "That could not be disconnected. Please try again.");
            });
        },
      },
      scondaryBtn: { caption: "Cancel", onClick: hideNoteAlert },
    });
  };

  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: PAGES.MYACCOUNT },
          { name: "AI Access", url: PAGES.AIACCESS },
        ]}
      />

      <section className="myAccount-section">
        <div className="container-fluid container-lg">
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">AI Access</h1>
                </div>
              </div>
            </div>

            <div className="col-md-11 col-lg-10">
              <p className="mt-3 mb-0 fs-15">
                An AI assistant can add products to your WES cart on your behalf. It asks for your approval in the
                browser first, and it never sees your password. Anything connected appears below, and you can disconnect
                it at any time.
              </p>

              <div className="row mt-5">
                <h3 className="website-settings-title">Connected applications</h3>
                <div className="col-lg-12">
                  {loading ? (
                    <p className="fs-15 mt-3">Loading&hellip;</p>
                  ) : grants.length === 0 ? (
                    <p className="fs-15 mt-3">
                      Nothing is connected yet.
                    </p>
                  ) : (
                    <div className="table-responsive mt-3">
                      <table className="table align-middle">
                        <thead>
                          <tr>
                            <th scope="col">Application</th>
                            <th scope="col">Connected</th>
                            <th scope="col">Last used</th>
                            <th scope="col">&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {grants.map((grant) => (
                            <tr key={grant.clientId}>
                              <td>{grant.clientName}</td>
                              <td>{formatDate(grant.connectedUtc)}</td>
                              <td>{grant.lastUsedUtc ? formatDate(grant.lastUsedUtc) : "Never"}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-link p-0 fs-14 pendingOrder-edit"
                                  onClick={() => handleDisconnect(grant)}
                                >
                                  Disconnect
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>

            </div>

            <BacktoMyAccount />
          </div>
        </div>
      </section>
    </>
  );
};
